import api from './api';

export const acceptBid = async (bidId) => {
  try {
    const response = await api.post(`/api/bid/${bidId}/action`, {
      action: 'accept'
    });
    return response.data;
  } catch (error) {
    console.error('Error accepting bid:', error);
    throw error;
  }
};

export const rejectBid = async (bidId) => {
  try {
    const response = await api.post(`/api/bid/${bidId}/action`, {
      action: 'reject'
    });
    return response.data;
  } catch (error) {
    console.error('Error rejecting bid:', error);
    throw error;
  }
};

export const cancelBid = async (bidId) => {
  try {
    const response = await api.post(`/api/bid/${bidId}/cancel`);
    return response.data;
  } catch (error) {
    console.error('Error cancelling bid:', error);
    throw error;
  }
};